export default __webpack_public_path__ + "static/MD_SearchThumb_Cloud_Storage-91c7a8d364b94ebd005597414ac39a89.webp";